/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_Remove_SelectedInputs */

const en_job_form_slot_generation_remove_selected = /** @type {(inputs: Job_Form_Slot_Generation_Remove_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove selected appointments`)
};

const de_job_form_slot_generation_remove_selected = /** @type {(inputs: Job_Form_Slot_Generation_Remove_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Termine entfernen`)
};

/**
* | output |
* | --- |
* | "Remove selected appointments" |
*
* @param {Job_Form_Slot_Generation_Remove_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_remove_selected = /** @type {((inputs?: Job_Form_Slot_Generation_Remove_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Remove_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_remove_selected(inputs)
	return en_job_form_slot_generation_remove_selected(inputs)
});